import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getPossibleResponsibleUsers from '../../api/get-possible-responsible-users';
import {
  getResponsibleUserReceive,
  getResponsibleUserReject,
  getResponsibleUserRequested,
} from '../actions/admin-page';

interface IGetPossibleResponsibleUsersAction {
  type: string;
  payload: {
    name: string
  }
}

interface IPossibleResponsibleUser {
  id: string
  name: string
}

function* getPossibleResponsibleUsersWorker(action: IGetPossibleResponsibleUsersAction) {
  try {
    const response: IPossibleResponsibleUser[] = yield call(getPossibleResponsibleUsers, action.payload.name);
    yield put(getResponsibleUserReceive({ users: response }));
  } catch (error) {
    yield put(getResponsibleUserReject({ error }));
  }
}

export default function* getPossibleResponsibleUsersWatcher() {
  yield takeLatest(getResponsibleUserRequested, getPossibleResponsibleUsersWorker);
}
